'use strict';

function Downloads() {
  $('#block-file-download a').click(function ($event) {
    $event.preventDefault();
    window.open($(this).attr('href'), '_blank');
  });
};
export default Downloads;
